import React from "react";

import cs from "classnames";

import { useGlobalContext } from "../../../lib/context/GlobalContext/GlobalContext";

import "./Hamburger.scss";

interface HamburgerProps {
  isNavBarMobileOpen: boolean;
  handleClick: () => void;
}
const Hamburger = (props: HamburgerProps) => {
  const { isNavBarMobileOpen, handleClick } = props;
  const headerColor = useGlobalContext().headerColor;

  return (
    <div
      className={cs("Hamburger", isNavBarMobileOpen && "Hamburger--open")}
      onClick={() => {
        handleClick();
      }}
    >
      <div
        className={cs(
          "Hamburger__menu",
          isNavBarMobileOpen && "Hamburger__menu--open",
          isNavBarMobileOpen && "Hamburger__menu-white--open",

          headerColor === "white" && "Hamburger__menu-white",
          headerColor === "gray" && "Hamburger__menu-white",
        )}
      ></div>
    </div>
  );
};

export default Hamburger;
